// eslint-disable-next-line import/prefer-default-export
export const JobTransferValidationType = Object.freeze({
    PrimaryJobOnly: 0,
    PrimaryJobAndTransferSet: 1,
});
